import lang from '@/lang'
import { dateFieldFilterComparator } from '@/modules/base/components/list/comparator'

export const ListDefaultSettings = {
  DATE_FILTER_OPTIONS: [
    'equals',
    'notEqual',
    {
      displayKey: 'greaterThan',
      displayName: lang.customListFilter.greaterThanDate,
      test: (filterValue, cellValue) => {
        return dateFieldFilterComparator(filterValue, cellValue) > 0
      },
    },
    {
      displayKey: 'lessThan',
      displayName: lang.customListFilter.lessThanDate,
      test: (filterValue, cellValue) => {
        return dateFieldFilterComparator(filterValue, cellValue) < 0
      },
    },
    'inRange',
  ],
  TEXT_FILTER_OPTIONS: [
    'contains',
    'notContains',
    'equals',
    'notEqual',
    'startsWith',
    'endsWith',
  ],
  NUMBER_FILTER_OPTIONS: [
    'equals',
    'notEqual',
    'lessThan',
    'lessThanOrEqual',
    'greaterThan',
    'greaterThanOrEqual',
    'inRange',
  ],
  BLANK_OPTIONS_FILTER_OPTIONS: [
    'blank',
    'notBlank',
  ],
}

export const ListDefaultExcelStyles = [
  {
    id: 'ExcelString',
    dataType: 'string',
  },
]

export const ListProps = {
  rowModelTypes: {
    client: 'clientSide',
    server: 'serverSide',
  },
}

/**
 * Marker class for a row actions cell.
 * The list ignores row clicks originating inside it, because its buttons handle their own clicks.
 */
export const LIST_ROW_ACTIONS_CLASS = 'listRowActions'
